import { useRecoilValue } from "recoil";
import calenderIcon from "../../../assets/svg/clenderIcon.svg";
import { formatDateTime } from "../../../utils/formatDateTime";
import { stateAtom } from "../../../atom";
import EditIcon from "../../../assets/EditIcon";
import Button from "../../../components/Button";
import { useNavigate } from "react-router-dom";
import { checkPermissions } from "../../../utils/helper";
import { formatCreatedDate } from "../../../utils/formatCreatedDate";

export default function ProjectDetails({ data }: any) {
  const navigate = useNavigate();
  const stateList = useRecoilValue(stateAtom);
  //Permissions
  const hasEditPermission = checkPermissions("edit_project");

  const orderFormattedDate: any = data?.created_at
    ? formatCreatedDate(data?.created_at, "date")
    : "-";
  const orderFormattedTime: any = data?.created_at
    ? formatCreatedDate(data?.created_at, "time")
    : "-";

  return (
    <div className="border-2 h-auto">
      <div
        className={`bg-[#FBFBFB] px-5 h-[45px] border-b-2 flex justify-between`}
      >
        <p className="font-medium text-[14px] py-2 leading-5">
          Project Details
        </p>
        <div className="py-1 mr-2">
          <Button
            label="Edit"
            leftIcon={<EditIcon />}
            variant="secondary"
            onClick={() => {
              navigate(`/projects/${data?.id}/edit`);
            }}
            className="py-1.5"
            disabled={!hasEditPermission}
            showNoPermissionTooltip={!hasEditPermission}
          />
        </div>
      </div>
      <div>
        <div className={`w-full px-5`}>
          <div className="flex flex-col items-baseline justify-between">
            <div className="flex items-center gap-8 my-2 w-full">
              <p className="text-[14px] flex font-gilroy-bold">
                {data?.name ?? ""}
              </p>
              <div className="flex items-center gap-3">
                <img src={calenderIcon} alt="calender-icon" />
                <div className="flex gap-2">
                  <p className="text-[#AEAEAE] font-gilroy-semi-bold text-[12px] tracking-normal">
                    {orderFormattedDate}
                  </p>
                  <p className="text-[#AEAEAE] font-gilroy-semi-bold text-[12px] tracking-normal">
                    {orderFormattedTime}
                  </p>
                </div>
              </div>
            </div>

            {data?.description && (
              <div className="flex flex-col my-2">
                {/* <p className="text-[14px] flex font-gilroy-bold">
                  {"Project Description"}
                </p> */}
                <p className="font-gilroy-regular text-[12px] my-2">
                  {data?.description ?? ""}
                </p>
              </div>
            )}
            <div className="flex gap-10">
              {(data?.address_state || data?.city) && (
                <div className="flex items-center gap-2 my-2 text-[12px] font-gilroy-bold">
                  <p className="text-[12px] flex font-gilroy-bold text-[#AEAEAE]">
                    Location:
                  </p>
                  <p>
                    {data?.address_city},{" "}
                    {
                      stateList?.find(
                        (state: any) =>
                          state?.state_code === data?.address_state
                      )?.name
                    }
                  </p>
                </div>
              )}

              <div className="flex items-center gap-2 my-2 mx-2 text-[12px] font-gilroy-bold">
                <p className="text-[12px] flex font-gilroy-bold text-[#AEAEAE]">
                  Project Type:
                </p>
                <p>{data?.project_type || "-"}</p>
              </div>

              <div className="flex items-center gap-2 mx-2 my-2 text-[12px] font-gilroy-bold">
                <p className="text-[12px] flex font-gilroy-bold text-[#AEAEAE]">
                  Project Area:
                </p>
                <p>{data?.project_area || "-"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
